import { useState } from "react";
import { api } from "services";
import useUniversalStore from "store/universalStore";

const ReportsView = ({ setReportLoading, type = "pdf" }) => {
  const accountId = useUniversalStore((state) => state.accountId);

  const handleDownload = async (value) => {
    setReportLoading((prev) => ({ ...prev, [type]: true }));
    const endMonth = new Date();
    let startMonth = new Date();
    startMonth.setHours(0, 0, 0, 0);

    if (value === 1) {
      startMonth.setDate(1);
    } else if (value === "lifetime") {
      startMonth = "lifetime";
    } else {
      startMonth.setMonth(endMonth.getMonth() - value);
    }
    // console.log(startMonth, endMonth);
    const result = type === "pdf" ? await api.downloadMonthlyReport(accountId, startMonth, endMonth) : await api.downloadMonthlyReportXLS(accountId, startMonth, endMonth);
    setReportLoading((prev) => ({ ...prev, [type]: false }));
    if (result == null) {
      alert(
        "Please try again later."
      );
    }
  }

  return (
    <div className="dropdown">
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li>
          <button className="dropdown-item" onClick={() => handleDownload(1)}>
            Latest Month
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => handleDownload(3)}>
            3 Months
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => handleDownload(6)}>
            6 Months
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => handleDownload(12)}>
            1 Year
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => handleDownload("lifetime")}>
            Lifetime
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ReportsView;